import errorHandler from '@mindfulchefuk/utils/errorHandler'
import { CMSPageHomepage } from '../interfaces'

export const getCMSHomepageContent = async (): Promise<CMSPageHomepage> => {
  try {
    const response = await fetch(
      `${process.env.NEXT_PUBLIC_CMS_API_BASE_URL}/page-homepage?populate=deep&simple=true`
    )

    if (response) {
      const data = await response.json()

      return {
        ...data,
      }
    }

    return null
  } catch (err) {
    errorHandler(err)
  }
}
